import React, { Component } from 'react';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Translate } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Breadcrumb, Button } from 'react-bootstrap';
import { Data } from 'react-data-grid-addons';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../Widgets/spinner';
import { DatePicker } from '../Common/datePicker';
import CashFormatter from '../Common/cashFormatter';
import GenericDatePicker from '../Common/GenericDatePicker';
import { getFromToDates } from '../Common/cleanDates';
import { InputField } from '../Common/inputField';
import { companyCodeTitle } from '../../actions/root_url';

momentLocalizer(moment);

class GeneralDashboard extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: 540,

        Messages: [],

        POs: {
          rows: [],
          allRows: [],
          setDate: null,
          selectedRows: null,
          sortColumn: null,
          sortDirection: null,
        },

        SOs: {
          rows: [],
          allRows: [],
          setDate: null,
          selectedRows: null,
          sortColumn: null,
          sortDirection: null,
        },

        MSOs: {
          rows: [],
          allRows: [],
          setDate: null,
          selectedRows: null,
          sortColumn: null,
          sortDirection: null,
        },

        poDateChosen: new Date(),
        soDateChosen: new Date(),
      };

      this.handleResize = this.handleResize.bind(this);
      this.addNewMessage = this.addNewMessage.bind(this);
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      this.props.fetchDashboardMessages();
      this.props.fetchIncomingOrdersByDate(getFromToDates(new Date()));
      this.props.fetchOutgoingOrdersByDate(getFromToDates(new Date()));
      this.props.setField('generalDashboard', 'selectedPODate', new Date());
      this.props.setField('generalDashboard', 'selectedSODate', new Date());
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
      if (nextProps.todaysIncomingOrders && nextProps.todaysIncomingOrders !== this.props.todaysIncomingOrders) {
        const POs = { ...this.state.POs, rows: nextProps.todaysIncomingOrders };
        this.setState({ POs });
      }

      if (nextProps.todaysOutgoingOrders && nextProps.todaysOutgoingOrders !== this.props.todaysOutgoingOrders) {
        const SOs = { ...this.state.SOs, rows: [...nextProps.todaysOutgoingOrders.SO] };
        const MSOs = { ...this.state.MSOs, rows: [...nextProps.todaysOutgoingOrders.MSO] };
        this.setState({ SOs, MSOs });
      }

      // if (nextProps.poDateChosen && nextProps.poDateChosen !== this.props.poDateChosen) {
      //   this.props.fetchIncomingOrdersByDate(getFromToDates(nextProps.poDateChosen));
      // }

      // if (nextProps.soDateChosen && nextProps.soDateChosen !== this.props.soDateChosen) {
      //   this.props.fetchOutgoingOrdersByDate(getFromToDates(nextProps.soDateChosen));
      // }

      if (nextProps.messages && nextProps.messages !== this.props.messages) {
          const Messages = nextProps.messages;
          this.setState({ Messages }, () => {
            this.updateScroll();
          });
        }
    }

    componentWillUnmount() {
      // window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.noButton });
    }

    updateScroll() {
      const element = document.getElementById('message-box');
      element.scrollTop = element.scrollHeight;
    }

    addNewMessage() {
      const newMessage = {
        message: this.props.Message,
      };
      this.props.postDashboardMessage(newMessage);
    }

    setPoDate = (e) => {
      this.setState(
        { poDateChosen: e },
        () => { this.props.fetchIncomingOrdersByDate(getFromToDates(this.state.poDateChosen)); },
      );
    }

    setSoDate = (e) => {
      this.setState(
        { soDateChosen: e },
        () => { this.props.fetchOutgoingOrdersByDate(getFromToDates(this.state.soDateChosen)); },
      );
    }

    // Render the table head and bind it to the datatable plugin to show a sortable table.
    renderPurchaseOrderTable() {
      if (this.props.todaysIncomingOrdersIsLoading && !this.props.todaysIncomingOrdersError) return <Spinner />;
      else if (this.props.todaysIncomingOrdersError) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.todaysIncomingOrdersError)}</div>
          </ContentWrapper>
        ); // Parameters of the react-data-grid
      }

      const getRows = () => {
        const Rows = Data.Selectors.getRows(this.state.POs);
        return Rows;
      };

      const getSize = () => {
        const RowSize = getRows().length;
        return RowSize;
      };

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const POs = { ...this.state.POs, sortColumn, sortDirection };
        this.setState({ POs });
      };

      // Handle the row select function

      const onRowSelect = (rows) => {
        const POs = { ...this.state.POs, selectedRows: rows };
        this.setState({ POs });
      };

      // Custom Formatter component

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      // Column difinition

      const columns = [
        {
          key: 'PONum',
          name: <Translate value="po_num" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'Vendor_Name',
          name: <Translate value="vendor" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: CashFormatter,
        },
        {
          key: 'OrderDate',
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },
        {
          key: 'ETADate',
          name: <Translate value="ETA" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },
        {
          key: 'Purchaser_User_Name',
          name: <Translate value="purchaser" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'PurchaseStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 110,
        },
      ];

      return (
      // React Table Purchase Orders
        <Row>
          <Col xs={12}>
            <div id="purchase-orders-arriving-table">
              <ReactDataGrid
                rowKey="PurchaseOrder_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={305}
                rowHeight={25}
                onRowSelect={onRowSelect}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderSalesOrderTable() {
      if (this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError) return <Spinner />;
      else if (this.props.todaysOutgoingOrdersError) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.todaysOutgoingOrdersError)}</div>
          </ContentWrapper>
        ); // Parameters of the react-data-grid
      }

      const getRows = () => {
        const Rows = Data.Selectors.getRows(this.state.SOs);
        return Rows;
      };

      const getSize = () => {
        const RowSize = getRows().length;
        return RowSize;
      };

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const SOs = { ...this.state.SOs, sortColumn, sortDirection };
        this.setState({ SOs });
      };

      // Custom Formatter component

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      // Column difinition

      const columns = [
        {
          key: 'SONum',
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          width: 120,
        },
        {
          key: 'Deliver_CustomerName',
          name: <Translate value="customer" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: CashFormatter,
        },
        {
          key: 'OrderDate',
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },
        {
          key: 'DispatchDate',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },
        {
          key: 'Sales_User_Name',
          name: <Translate value="sales" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'SaleStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 110,
        },
      ];

      return (
        <Row>
          <Col xs={12}>
            <div id="sales-orders-shipping-table">
              <ReactDataGrid
                rowKey="SalesOrder_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={305}
                rowHeight={25}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderMobileSalesOrderTable() {
      if (this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError || this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError) return;
      else if (this.props.todaysOutgoingOrdersError) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.todaysOutgoingOrdersError)}</div>
          </ContentWrapper>
        ); // Parameters of the react-data-grid
      }

      const getRows = () => {
        const Rows = Data.Selectors.getRows(this.state.MSOs);
        return Rows;
      };

      const getSize = () => {
        const RowSize = getRows().length;
        return RowSize;
      };

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const MSOs = { ...this.state.MSOs, sortColumn, sortDirection };
        this.setState({ MSOs });
      };

      // Custom Formatter component

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      // Column difinition

      const columns = [
        {
          key: 'SONum',
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          width: 120,
        },
        {
          key: 'Deliver_CustomerName',
          name: <Translate value="customer" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: CashFormatter,
        },
        {
          key: 'OrderDate',
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },
        {
          key: 'DispatchDate',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter,
        },
        {
          key: 'Sales_User_Name',
          name: <Translate value="sales" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true
        },
        {
          key: 'SaleStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 110,
        },
      ];

      return (
        <Row>
          <Col xs={12}>
            <h4 id="mso-header"><Translate value="mso_scheduled_shipping" /></h4>
            <div id="mobile-sales-orders-shipping-table">
              <ReactDataGrid
                rowKey="SalesOrder_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={305}
                rowHeight={25}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderMessages() {
      if (this.props.messagesIsLoading) {
        return (
          <Spinner />
        );
      }

      return (
        <Col xs={12}>
          {this.state.Messages.map((message) =>
            <Row className='user-message'>
              <Col xs={11}>
                <Panel>
                  <Row>
                    <Col xs={2}>
                      <span className='message-name'>{ message.Name }</span>:
                    </Col>
                    <Col xs={10}>
                      <div>
                        <span className='message-content'>{ message.Message }</span>
                      </div>
                    </Col>
                  </Row>
                </Panel>
              </Col>
              <Col xs={1} className='message-timestamp'>
                <Row>
                  <Col xs={12}>
                    <span className='pull-right'>
                      { moment(message.Date).format('h:mm A') }
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <span className='pull-right'>
                      { moment(message.Date).format('MM/DD/YYYY') }
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Col>
      );
    }

    render() {
      const { handleSubmit } = this.props;
      const purchaseOrderTablePanelHeader = (
        <Row>
          <Col xs={5}><h4><Translate value="po_scheduled_arrival" /></h4></Col>
          <Col xs={7} className="text-right">
            <h5 className="filter-title"><Translate value="eta_date" /><span className="colon">:</span></h5>
            {
              GenericDatePicker({
                setDate: this.setPoDate,
                selectedDate: this.state.poDateChosen,
              })
            }
          </Col>
        </Row>
      );
      const salesOrderTablePanelHeader = (
        <Row>
          <Col xs={5}><h4><Translate value="so_scheduled_shipping" /></h4></Col>
          <Col xs={7} className="text-right">
            <h5 className="filter-title"><Translate value="dispatch_date" /><span className="colon">:</span></h5>
            {
              GenericDatePicker({
                setDate: this.setSoDate,
                selectedDate: this.state.soDateChosen,
              })
            }
          </Col>
        </Row>
      );
      const mobileSalesOrderTablePanelHeader = (
        <Row>
          <Col xs={8}><h4><Translate value="mso_scheduled_shipping" /></h4></Col>
        </Row>
      );
      const messageBoardHeader = (
          <Row>
            <Col xs={12}>
              <h4 style={{ display: 'inline' }}>
                <Translate value="message_board" />
              </h4>
              {this.props.Message && this.props.Message.length > 499 && <div id='limit-warning'><Translate value="character_limit_reached" /> (500)</div>}
              <Button
                bsStyle='primary'
                id='refresh-button'
                onClick={this.props.fetchDashboardMessages}
              >
                <em className='fa fa-refresh' />
              </Button>
            </Col>
          </Row>
        );

      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item active="true">
              <Translate value="dashboard" />
            </Breadcrumb.Item>
          </Breadcrumb>
          <Grid id="general-dashboard" fluid="true">
            {/* Tables */}
            <Row>
              <form onSubmit={handleSubmit}>
                <Col xs={6}>
                  <Row>
                    <Col xs={12}>
                      <Panel header={purchaseOrderTablePanelHeader} className="table-collapse-fix-revision">
                        {this.renderPurchaseOrderTable() }
                      </Panel>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <Panel header={messageBoardHeader} id='message-panel'>
                        <Row id='message-box'>
                          {this.renderMessages()}
                        </Row>
                        <Row>
                          <Col xs={11}>
                            <Field
                              name='MessageField'
                              component={InputField}
                              maxLength='500'
                              onKeyPress={(event) => {
                                  if (event.charCode === 13) {
                                    if (this.props.Message.length > 0) {
                                      this.addNewMessage();
                                    }
                                  }
                                }
                              }
                            />
                          </Col>
                          <Col xs={1}>
                            <Button
                              bsStyle='primary'
                              className='pull-right'
                              onClick={this.addNewMessage}
                            >
                              <em className='fa fa-paper-plane-o' />
                            </Button>
                          </Col>
                        </Row>
                      </Panel>
                    </Col>
                  </Row>
                </Col>
                <Col xs={6}>
                  <Row>
                    <Col xs={12}>
                      <Panel header={salesOrderTablePanelHeader} className="sales-panel">
                        {this.renderSalesOrderTable() }
                        {this.renderMobileSalesOrderTable()}
                      </Panel>
                    </Col>
                  </Row>
                </Col>
              </form>
            </Row>
            {/* End Tables */}
          </Grid>
        </ContentWrapper>
      );
    }
}

export default GeneralDashboard;



// WEBPACK FOOTER //
// ./master/jsx/components/General/generalDashboardRevision.jsx